import React, {useEffect} from 'react'
import './ChoiceFeedback.scss'
import PersonAvatar from "../../common/PersonAvatar/PersonAvatar";
import Modal from "../../../../partials/Modal/SimpleModal/SimpleModal";
import Button from "../../../../partials/Button"
import FeedbackBlock from '../../../../partials/FeedbackBlock';
import ProgressProvider from '../../../MissionElements/providers/progressProvider';

function ChoiceFeedback({ show, rocketrep, speech, content, onClose, buttonCaption = 'Try Again', className}) {
    const [ repSpeech, setRepSpeech] = React.useState()
    const handleOnClose = () => {
        if (onClose) {
            onClose()
        }
    }
    useEffect(() => {
        setRepSpeech('')
    }, [])
    useEffect( () => {
        if (speech !== repSpeech) {
            setRepSpeech(speech)
        }
    }, [speech])

    return <Modal show={ show  } className={`${className}`}
                   >
                    <div className={"modal-holder"}>
                        <div className={"choicefeedback_container"} >
                            <div className={"choicefeedback_rocketrep"}>
                                <PersonAvatar {...rocketrep} speak={repSpeech} jobtitle={rocketrep.role}/>
                            </div>
                            <div className={"choicefeedback_content"} dangerouslySetInnerHTML={markUp(content)} />

                        </div>
                        <Button text={buttonCaption} onClick={handleOnClose} />
                    </div>

    </Modal>
    }

    function markUp(content) {
        return {
            __html: content
        }
    }
export default ChoiceFeedback;
